var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemParagraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.65 18v-4.282h3.17c2.687 0 4.18-1.763 4.18-3.85C17 7.763 15.526 6 12.82 6H7v12zm2.798-6.53H9.649V8.248h2.799c1.045 0 1.847.612 1.847 1.62 0 .989-.802 1.6-1.847 1.6"
})));
export default SvgGemParagraph;